module.exports = __webpack_public_path__ + "img/autofix-installed.d349501.png";